export const gridSizes = {
  xs: null,
  sm: 470,
  md: 750,
  lg: 1045,
  xl: 1250
};

export const minimumWidths = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1200,
  xl: 1500
}

export const widthToBreakpoint = (width = 0) => {
  if (width < 480) return 'xs';
  if (width < 768) return 'sm';
  if (width < 1200) return 'md';
  if (width < 1500) return 'lg';
  else return 'xl';
};

export const currentBreakpoint = () => {
  return widthToBreakpoint(window.innerWidth);
};

export const isCurrent = (...breakpoints) => {
  return breakpoints.includes(currentBreakpoint());
}

export const isSmallerThan = (breakpoint) => {
  return (breakpoint in minimumWidths ? window.innerWidth <= minimumWidths[breakpoint] : false);
}

export const breakpointToGridSize = (breakpoint = 'xs') => {
  return gridSizes[breakpoint];
};

export const widthToGridSize = (width) => {
  let breakpoint = widthToBreakpoint(width);
  let gridSize = breakpointToGridSize(breakpoint);
  return gridSize == null ? width : gridSize;
};

export const factorGridSize = (factor = 1, width = 0) => {
  let gridSize = widthToGridSize(width);
  return gridSize * factor;
};

export const autoWidth = () => {
  return widthToGridSize(window.innerWidth);
};

export const colWidth = (cols = 12) => {
  let gridSize = autoWidth();
  return gridSize * (1 / (12 / cols));
};

export const autoFactor = (factor = 1) => {
  return factorGridSize(factor, window.innerWidth);
};

export const divideGrid = (listSize, index = 0, maximumPerRow = 4) => {
  let gridWidth = 12;
  let fix = false;
  var candidate = {
    rowCount: listSize,
    hangingColumns: 12,
    columnSpan: gridWidth
  };
  let count = index + 1;
  let minimumWidth = Math.floor(gridWidth / maximumPerRow);

  if (!listSize) return gridWidth;

  for (let columnSpan = minimumWidth; columnSpan <= gridWidth; columnSpan++) {
    let totalColumnUsage = columnSpan * listSize;
    let lastRowColumnUsage = (totalColumnUsage <= gridWidth
      ? totalColumnUsage
      : totalColumnUsage % gridWidth
    );
    let hangingColumns = lastRowColumnUsage ? gridWidth - lastRowColumnUsage : 0;
    let rowCount = (totalColumnUsage + hangingColumns) / gridWidth;
    if (rowCount <= candidate.rowCount && hangingColumns <= candidate.hangingColumns) {
      candidate = { rowCount, hangingColumns, columnSpan };
    }
  }
  /*
    let totalColumnCount = count * candidate.columnSpan;
    let remainingCols = totalColumnCount % gridWidth;
  */
  return candidate.columnSpan;
};



// WEBPACK FOOTER //
// ./client/Core/Utils/BreakPoints.js